export default "__VITE_ASSET__DTthLQBf__"